import { trackOnboardingPageView } from "../helpers/productMetrics";

/**
 * Parses route information from pathname for onboarding tracking
 * @param {string} pathname - Current pathname
 * @returns {Object|null} Route info or null
 */
const parseRouteInfo = (pathname) => {
  // Profile registration: /profile/edit/registration/:section
  const profileRegMatch = pathname.match(
    /^\/profile\/edit\/registration\/(cv|work-history|personal-details|profile-picture|type-of-work|emergency-contact|demographics|personality-test)$/
  );
  if (profileRegMatch) {
    return {
      type: "profile card",
      step: profileRegMatch[1],
      section: "registration",
      jobId: null,
    };
  }

  // Profile legal compliance: /profile/edit/legal-compliance/:section
  const profileLegalMatch = pathname.match(
    /^\/profile\/edit\/legal-compliance\/(48-hour-opt-out|health-and-disability|contract-for-services|rtw)$/
  );
  if (profileLegalMatch) {
    return {
      type: "profile",
      step: profileLegalMatch[1],
      section: "legal-compliance",
      jobId: null,
    };
  }

  // Profile legal compliance yoti: /profile/edit/legal-compliance/rtw/yoti/:section
  const profileYotiMatch = pathname.match(
    /^\/profile\/edit\/legal-compliance\/rtw\/yoti\/(success|error)$/
  );
  if (profileYotiMatch) {
    return {
      type: "profile",
      step: `rtw-yoti-${profileYotiMatch[1]}`,
      section: "legal-compliance",
      jobId: null,
    };
  }

  // Job-specific registration: /profile/edit/job/:id/registration/:section
  const jobRegMatch = pathname.match(
    /^\/profile\/edit\/job\/([^/]+)\/registration\/(cv|work-history|personal-details|profile-picture|type-of-work|emergency-contact|demographics|personality-test)$/
  );
  if (jobRegMatch) {
    return {
      type: "job",
      step: jobRegMatch[2],
      section: "registration",
      jobId: jobRegMatch[1],
    };
  }

  // Job-specific legal compliance: /profile/edit/job/:id/legal-compliance/:section
  const jobLegalMatch = pathname.match(
    /^\/profile\/edit\/job\/([^/]+)\/legal-compliance\/(48-hour-opt-out|health-and-disability|contract-for-services|rtw)$/
  );
  if (jobLegalMatch) {
    return {
      type: "job",
      step: jobLegalMatch[2],
      section: "legal-compliance",
      jobId: jobLegalMatch[1],
    };
  }

  // Job-specific legal compliance yoti: /profile/edit/job/:id/legal-compliance/rtw/yoti/:section
  const jobYotiMatch = pathname.match(
    /^\/profile\/edit\/job\/([^/]+)\/legal-compliance\/rtw\/yoti\/(success|error)$/
  );
  if (jobYotiMatch) {
    return {
      type: "job",
      step: `rtw-yoti-${jobYotiMatch[2]}`,
      section: "legal-compliance",
      jobId: jobYotiMatch[1],
    };
  }

  // Custom onboarding forms: /profile/edit/job/:id/:section/:formId
  const jobCustomMatch = pathname.match(
    /^\/profile\/edit\/job\/([^/]+)\/(job-requirements|onboarding)\/([^/]+)$/
  );
  if (jobCustomMatch) {
    return {
      type: "job",
      step: jobCustomMatch[3],
      section: jobCustomMatch[2],
      jobId: jobCustomMatch[1],
    };
  }

  return null;
};

/**
 * Tracks onboarding page view based on current route
 * @param {string} pathname - Current pathname
 */
// eslint-disable-next-line import/prefer-default-export
export const trackOnboardingRoute = async (pathname) => {
  try {
    const routeInfo = parseRouteInfo(pathname);

    if (!routeInfo) {
      return;
    }

    const pageViewData = {
      type: routeInfo.type,
      step: routeInfo.step,
      section: routeInfo.section,
      jobId: routeInfo.jobId,
      pageUrl: pathname,
    };

    await trackOnboardingPageView(pageViewData);
  } catch (error) {
    console.error("Error tracking onboarding route:", error);
  }
};
